import { PathConstraint } from 'services/ContentfulService/constraints'
import { buildContentfulHooks } from 'services/ContentfulService/hooks/template'
import { Page, parsePage } from 'services/ContentfulService/models/page'
import { IPageFields } from 'generated/types/contentful'

export const [usePages, getPages, pageFetcher] = buildContentfulHooks<Page, IPageFields>('page', parsePage)

export const getPageDetails = async (path: string): Promise<Page> => {
	const pathClean = path.split('?')[0]
	const pages = await getPages({ constraints: [PathConstraint(pathClean)] })
	if (pages.length === 1) return pages.shift()!
	throw new Error('Error')
}
